import request from './request'
import type { LoginCredentials, LoginResponse, RegisterCredentials, User, UserRole } from '@/types/auth'

export interface AdminUserCreatePayload {
  username: string
  email: string
  password: string
  role: UserRole
}

export interface AdminUserUpdatePayload {
  email?: string
  role?: UserRole
  is_active?: boolean
  password?: string
}

export function login(data: LoginCredentials): Promise<LoginResponse> {
  const params = new URLSearchParams()
  params.append('username', data.username)
  params.append('password', data.password)

  return request.post<LoginResponse>('/auth/login', params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

export function register(data: RegisterCredentials): Promise<User> {
  return request.post<User>('/auth/register', {
    username: data.username,
    email: data.email,
    password: data.password,
  })
}

export function getCurrentUser(): Promise<User> {
  return request.get<User>('/auth/me')
}

export function getUsers(keyword?: string): Promise<User[]> {
  return request.get<User[]>('/users', { params: keyword ? { keyword } : undefined })
}

export function createUser(data: AdminUserCreatePayload): Promise<User> {
  return request.post<User>('/users', data)
}

export function updateUser(id: number, data: AdminUserUpdatePayload): Promise<User> {
  return request.put<User>(`/users/${id}`, data)
}

export function deleteUser(id: number): Promise<void> {
  return request.delete(`/users/${id}`)
}